import emailjs from "@emailjs/browser";

const emailJsConfig = {
  serviceId:
    process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_3cs0drh",
  templateId:
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_brjyd8x",
  publicKey:
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "ouiUBRAMjHGpdkE3k",
};

export const sendContactEmail = (formElement) => {
  if (!formElement) {
    throw new Error("The enquiry form is not available.");
  }

  const submissionUrl = window.location.href;
  const referrerUrl = document.referrer || "Direct visit / unavailable";
  const messageInput = formElement.elements.namedItem("user_project");

  const setHiddenField = (name, value) => {
    let input = formElement.elements.namedItem(name);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      formElement.appendChild(input);
    }

    input.value = value;
  };

  setHiddenField("submission_url", submissionUrl);
  setHiddenField("referrer_url", referrerUrl);
  setHiddenField("page_title", document.title);

  const originalMessage = messageInput ? messageInput.value.trim() : "";

  if (messageInput) {
    messageInput.value = [
      originalMessage,
      `Submitted Page: ${submissionUrl}`,
      `Visitor Source: ${referrerUrl}`,
    ].join("\n\n");
  }

  try {
    return emailjs.sendForm(
      emailJsConfig.serviceId,
      emailJsConfig.templateId,
      formElement,
      emailJsConfig.publicKey
    );
  } finally {
    if (messageInput) {
      messageInput.value = originalMessage;
    }
  }
};
